export const BRAINTREE_SDK_STABLE_VERSION = '3.95.0';
export const BRAINTREE_SDK_FASTLANE_COMPATIBLE_VERSION = '3.101.0-fastlane-beta.7.2';
export const BRAINTREE_SDK_LATEST_STABLE_VERSION = '3.104.0';
